<script lang="ts" setup>
// #影片連結
import { type Video } from '@/utils/types/Video'
import { extractVideoID } from '@/utils/helper'
const props = defineProps({
  data: {
    type: Object
  }
})

const videoData = ref()

const isVideoShow: Ref<boolean> = ref(false)

if (props.data) {
  const value: Ref<Video> = ref(props.data)
  videoData.value = value.value
}

const videoID = extractVideoID(videoData.value.url)

const handleClick = () => {
  isVideoShow.value = true
}
</script>

<template>
  <div class="area">
    <figure class="area__box">
      <div class="area__pic" @click="handleClick">
        <!-- <img :class="{ out: isVideoShow }" :src="videoData.image?.link" :title="videoData.image?.title"
          :alt="videoData.image?.alt" />
        <div class="area__btn" :class="{ out: isVideoShow }">
          <svg-icon class="area__btn__icon" name="icon-play" />
          <div class="area__btn__title">click to watch</div>
        </div> -->
        <!-- <div class="area__video" v-if="isVideoShow"> -->
        <div class="area__video">
          <iframe width="100%" height="100%"
            :src="`https://www.youtube.com/embed/${videoID}?controls=0&disablekb=1&modestbranding=1&playsinline=1&color=white&mute=1`"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </div>
      </div>
      <figcaption class="area__title">{{ videoData.title }}</figcaption>
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  position: relative;
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  img {
    display: block;
    width: 100%;
  }

  &__btn {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    transition: all 0.7s ease-in-out;

    &.out {
      opacity: 0;
    }

    &__icon {
      width: toRem(56);
      height: toRem(56);
      margin-bottom: toRem(10);
    }

    &__text {
      font-weight: 500;
      font-size: toRem(22);
    }
  }

  &__pic {
    position: relative;
    cursor: pointer;

    img {
      transition: all 0.7s ease-in-out;

      &.out {
        opacity: 0;
      }
    }
  }

  &__video {
    // position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
    /* 16:9 Aspect Ratio */
    width: 100%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    font-size: toRem(22);
    font-weight: 500;
    margin-top: toRem(10);
  }
}
</style>
